import { useEffect, useState } from 'react';

/**
 * The current instant, read again every `everyMs` - what a relative time (« il y a 23 min ») needs to
 * stay true on a screen nobody touches. The clock is a state and not a `Date.now()` in the render, so
 * the render stays a function of its inputs and a test can freeze the clock.
 */
export function useNow(everyMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), everyMs);
    return () => clearInterval(timer);
  }, [everyMs]);
  return now;
}
